import { StreamCoordinatesGet, StreamCoordinates } from "./interface";
import { Layout } from "./Layout";
import { assert, toDiv } from "../../utils";

export class FullScreenLayout implements Layout {
  constructor(private readonly config: Config) {}

  streamCoordinatesGet(
    streamCoordinatesGet: StreamCoordinatesGet
  ): StreamCoordinates {
    const { streamMargin } = this.config;
    const { x, y, width, height } =
      this.initialStreamCoordinatesGet(streamCoordinatesGet);

    const aspect = width / height;
    const width1 = toDiv(width - 2 * streamMargin, 8);
    const height1 = toDiv(width1 / aspect, 8);

    const padWidth = Math.floor((aspect * height1) / 2) * 2;
    const padX = Math.floor((width - padWidth) / 4) * 2;

    return {
      x: x + padX,
      y: y + (height - height1) / 2,
      width: padWidth,
      height: height1
    };
  }

  private initialStreamCoordinatesGet(
    streamCoordinatesGet: StreamCoordinatesGet
  ): StreamCoordinates {
    const { width, height } = this.config;
    const { streamIndex, streamsCount } = streamCoordinatesGet;

    switch (streamsCount) {
      case 1: {
        assert(
          [0].includes(streamIndex),
          `Invalid ${streamCoordinatesGet} data`
        );

        return {
          width,
          height,
          x: 0,
          y: 0
        };
      }
      default:
        assert(false, `Invalid streamsCount ${streamsCount}`);
    }
  }
}

interface Config {
  width: number;
  height: number;
  streamMargin: number;
}
